import { Filters } from "../../../../../Constant";
import { Col, Row } from "reactstrap";
import { ChevronDown } from "react-feather";
import { useAppDispatch } from "../../../../../Redux-Toolkit/Hooks";
import { setIsFilter } from "../../../../../Redux-Toolkit/Reducers/FilterSlice";
import { Sorting } from "./Sorting";
import { GridAndListView } from "./GridAndListView";
import { GridOptions } from "./GridOptions";

const ProductTotal = () => {
  const dispatch = useAppDispatch();

  return (
    <Row>
      <Col md="3" sm="12" className="products-total">
        <GridAndListView />
        <span className="d-none-productlist filter-toggle">
          {Filters}
          <span className="ms-2" onClick={() => dispatch(setIsFilter())}>
            <ChevronDown className="toggle-data" />
          </span>
        </span>
        <GridOptions />
      </Col>
      <Sorting />
    </Row>
  );
};

export default ProductTotal;
